/**
 * @file PaddlePaddleFoundathon-2023-8
 * @author v_duzhengqiang
 */
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'location-origin';
import React from 'react';
import ReactDOM from 'react-dom';

import PaddlePaddleFoundathon from './PaddlePaddleFoundathon';

import './style.less';

ReactDOM.render(<PaddlePaddleFoundathon />, document.getElementById('root'));
